import {Injectable}                     from '@angular/core';
import {HttpClient}                     from "@angular/common/http";

import {Sport}                          from './sport';
import {AngularQuery}                   from "../query/angularquery";

import {Observable}                     from "rxjs";


/**
 * Handle interactions for the Angular ReST API for the "sport" table.
 *
 */
@Injectable()
export class SportService {

	/**
	 * Initialize the object.
	 *
	 * @param {HttpClient} http  Connection to HTTP.
	 */
	constructor(protected http: HttpClient) {}


	/**
	 * Get the list of Sports as an Observable.
	 *
	 * @returns {any}  An array of Sports or an error.
	 */
	getSports(): Observable<Sport[]> {

		let sptquery: AngularQuery = new AngularQuery();
		sptquery.setEndpoint(AngularQuery.ENDPOINT_SPORT);
		let sportsUrl: string = sptquery.getUrl();
		return this.http
			.get<Sport[]>(sportsUrl);

	}

}



// WEBPACK FOOTER //
// ./src/app/services/sport/sport.service.ts